export default __webpack_public_path__ + "static/media/dark24.68d4fa2f.png";